import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { logout } from "../services/Logout";

// Mobile-only dashboard navigation: the sidebar (.panelSidebar) is hidden
// under 992px, so this horizontally-scrollable pill bar takes its place.
export default function DashMobileNav({ items }) {
    const { t } = useTranslation();
    const chatlist = useSelector((state) => state.chatListReducer);
    const unread = chatlist?.data?.reduce((sum, c) => sum + (Number(c?.unread_count) || 0), 0) || 0;

    return (
        <nav className="dash-mobile-nav d-lg-none" aria-label={t("dashMobileNav.dashboard_navigation")}>
            {items.map((item) => (
                <NavLink key={item.to} to={item.to} end={item.end} className="dash-mobile-link">
                    <i className={item.icon} />
                    <span>{item.label}</span>
                    {item.badge === 'unread' && unread > 0 &&
                        <span className="dash-mobile-badge">{unread}</span>
                    }
                </NavLink>
            ))}
            <a href="#" className="dash-mobile-link" onClick={logout}>
                <i className="fa-light fa-power-off" />
                <span>{t("dashMobileNav.logout")}</span>
            </a>
        </nav>
    );
}
